/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconInputX = createReactComponent("input-x", "IconInputX", [
  [
    "path",
    {
      d: "M20 13v-4a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h7",
      key: "svg-0"
    }
  ],
  ["path", { d: "M22 22l-5 -5", key: "svg-1" }],
  ["path", { d: "M17 22l5 -5", key: "svg-2" }]
]);

export { IconInputX as default };
//# sourceMappingURL=IconInputX.js.map
